import HelpText from "./form/HelpText"
import Input from "./form/Input"
import React, { useState } from "react"
import PropTypes from "prop-types"
import { useForm } from "react-hook-form"
import getDate from "../libs/getDate"
import CustomColorRing from "./form/ColorRing"
import { edmCheck, sendToGoogleSheet } from "../libs/function"
import { navigate } from "gatsby"
import { SendToGoogleSheetId } from "../libs/getSheetId"

const SubscribeForm = ({ onSuccess, customClass = "" }) => {
  const [isPending, setIsPending] = useState(false)
  const curUrl = typeof window !== "undefined" ? window.location.pathname : null

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm()

  const onSubmit = async data => {
    try {
      const { name, email } = data

      await setIsPending(true)
      const currentTime = getDate()

      const body = JSON.stringify({
        name,
        email,
        dayOfCycle: 0,
        campaign: {
          campaignId: "qvwPF",
        },
      })
      const formData = {
        rows: {
          name: name,
          email: email,
          type: "post",
          slug: curUrl,
          date: currentTime,
        },
        docId: SendToGoogleSheetId.default,
        sheetId: "281173528", // 工作表名稱：EDM訂閱名單
      }

      // 透過edm.js檢查是否重複或格式有誤
      const result = await edmCheck(body)

      // 若回傳status===200，則寫入google-sheet
      if (result.status === 200) {
        await sendToGoogleSheet(formData)

        await setIsPending(false)
        await reset()
        await onSuccess()
        await navigate(`${curUrl}?edmSuccess=true`)
      } else if (result.status === 400) {
        await setIsPending(false)
        alert("信箱格式錯誤")
      } else if (result.status === 409) {
        await setIsPending(false)
        alert("您的 email 已經訂閱，若有問題請加 LINE 詢問")
      } else {
        await setIsPending(false)
        alert("發生錯誤! 請加line聯繫我們")
      }
    } catch (e) {
      await setIsPending(false)
      alert("發生錯誤! 請加line聯繫我們")
    }
  }

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="grid grid-cols-1 col-span-2 gap-4 p-6 bg-gray-100 sm:justify-self-stretch"
      id="collapseTop"
    >
      <p className="!leading-normal text-center font-bold text-gray-900 sm:text-left sm:text-lg">
        訂閱 Welly 電子報，定期補充行銷新知
      </p>
      <input
        {...register("name", {
          required: true,
          minLength: 2,
          maxLength: 128,
        })}
        placeholder="希望 Welly 如何稱呼您？"
        className={`w-full h-10 pl-4 text-sm outline-none tracking-wide text-gray-900 border-b border-b-gray-900 placeholder:text-gray-400 focus:border-b-2 ${customClass} ${
          errors["name"] ? "border-b-yellow-500" : ""
        }`}
      />
      {errors["name"] && <HelpText text="*此為必填項目(兩字以上)" />}
      <Input
        name="email"
        register={register}
        isRequired={true}
        placeholder="您常用的 Email"
        errors={errors["email"]}
      />
      {errors["email"] && <HelpText text="*此為必填項目" />}
      {isPending ? (
        <CustomColorRing />
      ) : (
        <button
          type="submit"
          className="block mx-auto py-3 px-5 text-xl font-medium text-gray-900 bg-yellow-300 transition ease-in-out duration-150 hover:bg-yellow-400 active:bg-yellow-500 sm:mr-auto sm:ml-0"
        >
          訂閱
        </button>
      )}
    </form>
  )
}
SubscribeForm.propTypes = {
  onSuccess: PropTypes.func,
  customClass: PropTypes.string,
}

export default SubscribeForm
